import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-modal'
import SignatureZoom from './signatureZoom'
import SignatureList from './signatureList'
import signatureGenerator, {replacePlaceholderToTransparentLogo, replaceTransparentLogoToPlaceholder,
    generateSignatureReplaceData, generateUniqueHashFromSignatureData, replacePlaceholderToNothing}
        from './signatureGenerator'
import styles from './signatures.scss'
import {loadSignatures, zoomSignature, closeSignature, removeSignatureById, setSignature,
    setNotification} from 'state/actions'
import i18n from 'lib/i18n'
import moment from 'moment'
import nesProp from 'nested-property'
import c from 'state/constants'

const _ = i18n('office')

/* export const SignatureNameValue = ({signature}) => {
	const {name} = signature
	if (!name) {return <span>? ?</span>}
	const fullName = name.first + ' ' + name.last
	return (
		<div>{fullName}</div>
	)
}

SignatureNameValue.propTypes = {
	signature: PropTypes.object,
} */

@connect(state => ({
    currentBrNr: state.app.brNr,
    broker: state.office.brokers[state.app.brNr],
    brokers: state.office.brokers,
    app: state.app,
    signatures: state.office.signatures,
    signatureZoom: state.office.signatureZoom,
    signatureModal: state.office.signatureModal,
    lang: state.app.lang,
}))
export default class Signature extends React.Component {
    static propTypes = {
        signatures: React.PropTypes.array,
        signatureZoom: React.PropTypes.object,
        signatureModal: React.PropTypes.object,
        dispatch: React.PropTypes.func.isRequired,
        lang: PropTypes.string,
    }

    constructor(props) {
        super(props)
        this.onSignatureClicked = this.onSignatureClicked.bind(this)
        this.onRemoveSignature = this.onRemoveSignature.bind(this)
        this.onCloseSignature = this.onCloseSignature.bind(this)
        this.onSaveSignature = this.onSaveSignature.bind(this)

        this.state = {canGenerateSignatureAgain: true}
    }

	componentDidMount() {
      const {dispatch, currentBrNr, signatures} = this.props
  		dispatch(closeSignature())

  		this.refresh().then((response) => {
          if (currentBrNr) {
              this.setState({canGenerateSignatureAgain: false}, () => {
                  this.createOrUpdateSignatureAutomaticForBroker(currentBrNr)
              })
          }
      })
  }

    refresh() {
        const {dispatch} = this.props
        return dispatch(loadSignatures()).then(()=>{
            this.forceUpdate()
        })
    }

    /**
     * This dedicated function is called on every property received.
     * One of the scope of usage is to generate a new signature for brokers woh don't have any.
     * @param {object} nextProps
     */
    componentWillReceiveProps(nextProps) {
        const {currentBrNr, signatureZoom} = this.props
        // create signature automatically if not exist minimum 1 piece.
        // TODO thinking about to prevent the double start of this creation, but I think this never happen :),
        // asynchronous creation of signatures can cause that.
        let brokerNumberChanged = nextProps.currentBrNr !== currentBrNr
        let noSignatureOpenForEdit = (!signatureZoom || !signatureZoom.visible)
        if ( brokerNumberChanged && noSignatureOpenForEdit && this.state.canGenerateSignatureAgain) {
            this.setState({canGenerateSignatureAgain: false}, () => {
                this.createOrUpdateSignatureAutomaticForBroker(nextProps.currentBrNr)
            })
        }
    }

    /**
     * This function will create an automatic signature for a broker if not exist.
     * Should return a promise
     */
    createOrUpdateSignatureAutomaticForBroker(brNr, signature, customUpdate) {
        const {signatures, dispatch, brokers, lang, app} = this.props

        // quick check of params
        if (!brNr) { return false }

        // search an existing signature if to be sure is not created before
        let signatureOfBrokerExists = false
        let isUpdateSignature = false

        // signature parameter is not empty we check that one first
        if (signature) {
            isUpdateSignature = true
        }

        if (signatures && Array.isArray(signatures) && signatures.length > 0) {
            let matches = signatures.filter(item => (item.brokerNumber == brNr))
            if ( matches.length > 0 ) {
                signatureOfBrokerExists = true
            }
        }

        const theBroker = brokers && brokers[brNr] || false

        if (!theBroker || !theBroker.main) {
                return ''
        }

        const theBrokerName = theBroker.main && theBroker.main.name || ""

        let userFullName = ((app.firstName || "") + " " + (app.lastName || ""))
        userFullName = String(userFullName).trim()

        // if we don't have minimum 1 signature for this broker we have to generate one automatically.
        if (!signatureOfBrokerExists || isUpdateSignature) {
            //this.getNewSignatureTable(brNr)

            dispatch({type: c.SHOW_LOADER})

            signatureGenerator(theBroker, app.userId, userFullName, lang)
            .then((content) => {
                let defaultValuesForASignature = this.getDefaultValuesForANewSignature()
                let replacementData = generateSignatureReplaceData(theBroker,app.userId, userFullName, lang)
                defaultValuesForASignature.name = theBrokerName + " - " + brNr + " (" + moment().format("DD-MM-YYYY HH:mm:ss") + ")"
                defaultValuesForASignature.content = content
                defaultValuesForASignature.isDefault = true
                defaultValuesForASignature.brokerNumber = brNr
                defaultValuesForASignature.generatedHash = generateUniqueHashFromSignatureData(replacementData)

                if (isUpdateSignature) {
                    defaultValuesForASignature.isDefault = signature.isDefault
                    defaultValuesForASignature._id = signature._id

                    if (customUpdate === true) {
                        defaultValuesForASignature.name = signature.name
                        defaultValuesForASignature.content = signature.content
                    }
                }

                return defaultValuesForASignature
            })
            .then((signaturePlainObj) => {
                this.saveSignature(signaturePlainObj).then((signatureRecord)=>{

                    // refresh the list, if this request is not started by the save action automatically
                    this.refresh().then(()=>{
                        this.setState({canGenerateSignatureAgain: true})
                    })

                    dispatch(setNotification(_('signatureCreatedFor') + " " + brNr, 'success'))
                })
            })
            // the same action in "catch" and "then" because the "finally" not supported in IE
            .then((result)=>{
                dispatch({type: c.HIDE_LOADER})
                return result
            })
            .catch((err)=>{
                dispatch({type: c.HIDE_LOADER})
                return err
            })
        } else {
            this.setState({canGenerateSignatureAgain: true})
        }
    }

    /**
     * This function give a set of default value for rendering a signature in the renderer initialization
     * on creating a new signature.
     */
    getDefaultValuesForANewSignature() {
        return {
            name: "",
            content: "",
            isDefault: false,
            createdAt: "",
            updatedAt: "",
            generatedHash: "",
        }
    }

    /**
     * Event when you select a signature from list. This will set the Id for the detailed page to
     * identify the affected record to show.
     * @param {string} id
     */
	onSignatureClicked(id) {
		const {dispatch} = this.props
		dispatch(zoomSignature(id))
    }

    /**
     * This action will handle the deletion of a signature.
     * @param {object} signature
     */
	onRemoveSignature(signature) {
        const {dispatch} = this.props
		const r = confirm(_('removeConfirmation'))
		if (r === true) {
			dispatch(removeSignatureById(signature._id))
			dispatch(closeSignature())
		}
    }

    /**
     * This action will handle the update of a signature.
     * @param {object} signature
     * @param {bool} customUpdate set this true if the content of the signature is custom, and you don't want auto generation
     */
	onUpdateSignature(signature, customUpdate) {
        const {dispatch} = this.props

        if (!customUpdate) {
            customUpdate = false
        }

        let result = this.createOrUpdateSignatureAutomaticForBroker(signature.brokerNumber, signature, customUpdate)

        if (result) {
            result.then(()=>{
                this.refresh()
            })
        }
    }

    /**
     * This action will handle the deletion of a signature.
     */
	onRemoveSignature(signature) {
        const {dispatch} = this.props
		const r = confirm(_('removeConfirmation'))
		if (r === true) {
			dispatch(removeSignatureById(signature._id))
			dispatch(closeSignature())
		}
    }

    /**
     * Exiting event from detailed view of a signature.
     */
	onCloseSignature() {
        const {dispatch, signatureZoom} = this.props

        // clean up the visible placeholder
        /* if (signatureZoom && signatureZoom.content) {
            signatureZoom.content = replacePlaceholderToTransparentLogo(signatureZoom.content)
        } */

		dispatch(closeSignature())
    }

    /**
     * Event for set a signature to be default.
     */
	onSetDefaultSignature(signature) {
        const {dispatch} = this.props

        if (!signature) {
            return
        }

        const newSignature = {
            _id: signature._id,
            isDefault: !signature.isDefault,
            brokerNumber: signature.brokerNumber,
        }

        dispatch(setSignature(newSignature)).then((signatureRecord)=>{
            dispatch(setNotification(signatureRecord.name + ' - ' +
            ((!signature.isDefault) ? _('markedAsDefault') : _('markedAsNotDefault')),
            'success'))
        })
    }

    /**
     * Save signature action dispatch
     * @param {*} signature
     */
    saveSignature(signature) {
        const {dispatch, brokers} = this.props

        if (!signature || !signature.brokerNumber) {
            return
        }


        let canEdit = brokers && nesProp.get(brokers, signature.brokerNumber + ".main.modifySignature")
        canEdit = (canEdit === "false" ? false : (canEdit === "true" ? true : !!canEdit))

        if (signature.content) {
            if (canEdit) {
                signature.content = replacePlaceholderToTransparentLogo(signature.content)
            } else {
                signature.content = replacePlaceholderToNothing(signature.content)
            }

        }

        const newSignature = {
            _id: signature._id,
            name: signature.name,
            content: signature.content,
            isDefault: signature.isDefault,
            brokerNumber: signature.brokerNumber,
            generatedHash: signature.generatedHash
        }


        console.log("setSignature newSignature", newSignature)

        return dispatch(setSignature(newSignature))
    }

    /**
     * Event for save a signature record. Update create.
     * @param {object} signature
     */
	onSaveSignature(signature) {
        const {dispatch} = this.props

        if (!signature) {
            return
        }

        const newSignaturePromise = this.saveSignature(signature)

        if (newSignaturePromise) {
            newSignaturePromise.then((signatureRecord)=>{
                // dispatch(zoomSignature(signatureRecord._id))
                // dispatch(setNotification(_('signatureSaved'), 'success'))
            })
        }
    }

    /**
     * Dedicated main rendering method.
     */
	render() {
        const {signatures, signatureZoom, lang, app, brokers, dispatch} = this.props

		let signature = {}
		let initialValues = {}

		if (signatureZoom && signatureZoom.visible) {
			signature = signatures && signatures.filter(item => (item._id === signatureZoom.signatureId))[0] || {}
		}

		return (
			<div className={styles.signaturesTable}>
				{(!signatureZoom || !signatureZoom.visible)
                    ?
						<SignatureList
							signatures={signatures || []}
                            onSignatureClicked={this.onSignatureClicked}
                            onSetDefaultSignature={(resultSign)=>{
                                this.onSetDefaultSignature(resultSign)
                            }}
                            onUpdateSignature = {(resultSign,customUpdate) => {
                                this.onUpdateSignature(resultSign,customUpdate)
                            }}
                        />
                    :
                        <SignatureZoom
                            signature={signature}
                            onRemoveSignature={(resultSign)=>{
                                this.onRemoveSignature(resultSign)
                            }}
                            onUpdateSignature = {(resultSign, customUpdate)=>{
                                this.onUpdateSignature(resultSign, customUpdate)
                            }}
                            onCloseSignature = {this.onCloseSignature}
                            onSetDefaultSignature = {(resultSign)=>{
                                this.onSetDefaultSignature(resultSign)
                            }}
                            onSaveSignature={(resultSign)=>{
                                this.onSaveSignature(resultSign)
                            }}
                            getNewSignatureTable = {(paramBrNr) => {
                                const theBroker = brokers && brokers[paramBrNr] || false

                                if (!theBroker || !theBroker.main) {return ''}

                                let userFullName = ((app.firstName || "") + " " + (app.lastName || ""))
                                userFullName = String(userFullName).trim()

                                dispatch({type: c.SHOW_LOADER})
                                return signatureGenerator(theBroker, app.userId, userFullName, lang)
                                // the same action in "catch" and "then" because the "finally" not supported in IE
                                .then((result)=>{
                                    dispatch({type: c.HIDE_LOADER})
                                    return result
                                })
                                .catch((err)=>{
                                    dispatch({type: c.HIDE_LOADER})
                                    return err
                                })
                            }}
                            signatureDefaultValues={() => (this.getDefaultValuesForANewSignature())}
                            replaceTransparentLogoToPlaceholder={(content)=>replaceTransparentLogoToPlaceholder(content, lang)}
                        />
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/signature.jsx